import Layout from '../../../common/Layout/Layout';
import CourseTile, { CourseType } from './CourseTile/CourseTile';
import PureLink from '../../../common/Link/PureLink';
import { useInternalComponent } from '../../../../lib/context/InternalComponentContext';
import { classes, ClassType } from '../../../../lib/utils/cssUtils';
import styles from './TrainingSummaryView.module.scss';

export type TrainingSummaryTile = {
  id: string;
  type: CourseType;
  value?: number;
  link?: string;
};

type TrainingSummaryProps = {
  heading?: string;
  tiles: TrainingSummaryTile[];
  classNames?: Record<'root' | 'course', ClassType>;
};

export type CoursesSummary = {
  totalAssigned?: number;
  totalCompleted?: number;
  totalInProgress?: number;
  totalOverdue?: number;
  totalNotStarted?: number;
};

const TrainingSummaryView = ({ heading, tiles, classNames }: TrainingSummaryProps) => {
  const onlyDefinedTiles = tiles.filter(tile => typeof tile?.value !== 'undefined');
  const { internal } = useInternalComponent();

  return (
    <Layout className={classes(styles.summaryLayout, classNames?.root, { [styles.fillContainer]: internal })}>
      <div className={styles.summaryGrid}>
        <div className={styles.titleRow}>
          <div className={styles.title}>{heading ? <h2 className={styles.heading}>{heading}</h2> : null}</div>
        </div>
        {onlyDefinedTiles.map(({ type, id, value, link }, index) => (
          <div
            className={classes(index === 0 ? styles.courseFirst : styles.course, classNames?.course)}
            data-testid={id}
            key={id}
          >
            {link ? (
              <PureLink href={link}>
                <CourseTile
                  type={type}
                  labelKey={`courses.progress.${type}`}
                  quantity={value!}
                  highlighted={index === 0}
                />
              </PureLink>
            ) : (
              <CourseTile
                type={type}
                labelKey={`courses.progress.${type}`}
                quantity={value!}
                highlighted={index === 0}
              />
            )}
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default TrainingSummaryView;
